import Vue from 'vue'
import Vuex from 'vuex'
import mainStore from './store/'

Vue.use(Vuex)

export default new Vuex.Store(mainStore)
